"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=function(){return null};e.displayName="Scrollbar.HorizontalScrollbar",exports.default=e;
